var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg20 = function Svg20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54 3.707a.65.65 0 0 1 .92 0l5.833 5.833a.65.65 0 0 1 0 .92l-5.833 5.833a.65.65 0 0 1-.92-.92l4.724-4.723H4.167a.65.65 0 1 1 0-1.3h10.097L9.54 4.626a.65.65 0 0 1 0-.919Z",
    fill: "currentColor"
  })));
};

export { Svg20 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjU0MDM4IDMuNzA3MDVDOS43OTQyMiAzLjQ1MzIxIDEwLjIwNTggMy40NTMyMSAxMC40NTk2IDMuNzA3MDVMMTYuMjkyOSA5LjU0MDM4QzE2LjU0NjggOS43OTQyMiAxNi41NDY4IDEwLjIwNTggMTYuMjkyOSAxMC40NTk2TDEwLjQ1OTYgMTYuMjkzQzEwLjIwNTggMTYuNTQ2OCA5Ljc5NDIyIDE2LjU0NjggOS41NDAzOCAxNi4yOTNDOS4yODY1NCAxNi4wMzkxIDkuMjg2NTQgMTUuNjI3NiA5LjU0MDM4IDE1LjM3MzdMMTQuMjY0MSAxMC42NUg0LjE2NjY2QzMuODA3NjggMTAuNjUgMy41MTY2NiAxMC4zNTkgMy41MTY2NiAxMEMzLjUxNjY2IDkuNjQxMDIgMy44MDc2OCA5LjM1IDQuMTY2NjYgOS4zNUgxNC4yNjQxTDkuNTQwMzggNC42MjYyOUM5LjI4NjU0IDQuMzcyNDQgOS4yODY1NCAzLjk2MDg5IDkuNTQwMzggMy43MDcwNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";